export let MIN_KTP_LENGTH = 8;
